import { render, staticRenderFns } from "./monitoringSystem.vue?vue&type=template&id=1825f304&scoped=true"
import script from "./monitoringSystem.vue?vue&type=script&lang=js"
export * from "./monitoringSystem.vue?vue&type=script&lang=js"
import style0 from "./monitoringSystem.vue?vue&type=style&index=0&id=1825f304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825f304",
  null
  
)

export default component.exports